import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Navigation from "./components/Navigation";
import Home from "./components/Pages/Home";
import Semesters from "./components/Pages/Semesters";
import SemesterDetail from "./components/Pages/SemesterDetail";
import SemesterAdd from "./components/Pages/SemesterAdd";
import Courses from "./components/Pages/Courses";
import CourseDetail from "./components/Pages/CourseDetail";
import Classes from "./components/Pages/Classes";
import ClassDetail from "./components/Pages/ClassDetail";
import Lecturers from "./components/Pages/Lecturers";
import LecturerDetail from "./components/Pages/LecturerDetail";
import Students from "./components/Pages/Students";
import StudentDetail from "./components/Pages/StudentDetail";
import StudentsImport from "./components/Pages/StudentsImport";
import Login from "./components/Registration/Login";
import Logout from "./components/Pages/Logout";
import UpdateGrade from "./components/Pages/UpdateGrade";
import ProfileDetail from "./components/Pages/ProfileDetail";
import StudentEnrollmentCreate from "./components/Pages/StudentEnrollmentCreate";
import StudentEnrollmentUpdate from "./components/Pages/StudentEnrollmentUpdate";
import StudentEnrollmentDelete from "./components/Pages/StudentEnrollmentDelete";
import SemesterUpdate from "./components/Pages/SemesterUpdate";
import SemesterDelete from "./components/Pages/SemesterDelete";
import CourseAdd from "./components/Pages/CourseAdd";
import CourseUpdate from "./components/Pages/CourseUpdate";
import CourseDelete from "./components/Pages/CourseDelete";
import ClassAdd from "./components/Pages/ClassAdd";
import ClassUpdate from "./components/Pages/ClassUpdate";
import ClassDelete from "./components/Pages/ClassDelete";
import LecturerAdd from "./components/Pages/LecturerAdd";
import LecturerUpdate from "./components/Pages/LecturerUpdate";
import LecturerDelete from "./components/Pages/LecturerDelete";
import StudentAdd from "./components/Pages/StudentAdd";
import StudentUpdate from "./components/Pages/StudentUpdate";
import StudentDelete from "./components/Pages/StudentDelete";
import {useEffect, useState} from "react";
import axios from "./components/axios";

function App() {
     const [token, setToken] = useState(localStorage.getItem('access_token'));

    useEffect(() => {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            delete axios.defaults.headers.common['Authorization'];
        }
    }, [token]);
    return (
        <div className="App">
            <Router>
                <Navigation/>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/semesters/" element={<Semesters/>}/>
                    <Route path="/semesters/:id" element={<SemesterDetail/>}/>
                    <Route path="/semester/create" element={<SemesterAdd/>}/>
                    <Route path="/semester/update/:id" element={<SemesterUpdate/>}/>
                    <Route path="/semester/delete/:id" element={<SemesterDelete/>}/>
                    <Route path="/courses" element={<Courses/>}/>
                    <Route path="/course/:id" element={<CourseDetail/>}/>
                    <Route path="/courses/create" element={<CourseAdd/>}/>
                    <Route path="/courses/update/:id" element={<CourseUpdate/>}/>
                    <Route path="/courses/delete/:id" element={<CourseDelete/>}/>
                    <Route path="/classes" element={<Classes/>}/>
                    <Route path="/class/:id" element={<ClassDetail/>}/>
                    <Route path="/class/create" element={<ClassAdd/>}/>
                    <Route path="/class/update/:id" element={<ClassUpdate/>}/>
                    <Route path="/class/delete/:id" element={<ClassDelete/>}/>
                    <Route path="/lecturers" element={<Lecturers/>}/>
                    <Route path="/lecturer/:id" element={<LecturerDetail/>}/>
                    <Route path="/lecturer/create" element={<LecturerAdd/>}/>
                    <Route path="/lecturer/update/:id" element={<LecturerUpdate/>}/>
                    <Route path="/lecturer/delete/:id" element={<LecturerDelete/>}/>
                    <Route path="/students" element={<Students/>}/>
                    <Route path="/student/:id" element={<StudentDetail/>}/>
                    <Route path="/student/create" element={<StudentAdd/>}/>
                    <Route path="/student/update/:id" element={<StudentUpdate/>}/>
                    <Route path="/student/delete/:id" element={<StudentDelete/>}/>
                    <Route path="/student/import" element={<StudentsImport/>}/>
                        <Route path="/login" element={<Login setToken={setToken} />} />
                <Route path="/logout" element={<Logout setToken={setToken} />} />
                    <Route path="/student_enrollment/:id" element={<StudentEnrollmentUpdate/>}/>
                    <Route path="/profile/:username" element={<ProfileDetail/>}/>
                    <Route path="/student_enrollment/create" element={<StudentEnrollmentCreate/>}/>
                    <Route path="/student_enrollment/update_grade/:id" element={<UpdateGrade/>}/>
                    <Route path="/student_enrollment/delete/:id" element={<StudentEnrollmentDelete/>}/>
                </Routes>
            </Router>
        </div>
    );
}

export default App;
